import api from './client';

export interface CatalogProduct {
  product_id: number;
  title: string;
  price: number;
  inventory: number;
  units_sold: number;
}

export type PriceRecommendationType = 'price_increase' | 'clearance_discount';

export interface PriceRecommendationItem {
  type: PriceRecommendationType;
  product_title: string;
  current_price: number;
  suggested_price_change_percent: number;
  suggested_price?: number;
  rationale: string;
  expected_impact: string;
}

export interface PriceOptimizationInsight {
  id: number;
  period_start: string;
  period_end: string;
  orders_analyzed: number;
  bestsellers: CatalogProduct[];
  slow_movers: CatalogProduct[];
  ai_summary: string | null;
  ai_recommendations: PriceRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GeneratePriceOptimizationPayload {
  days?: number;
}

export const priceOptimizationApi = {
  list: (page = 1) =>
    api.get<{ data: PriceOptimizationInsight[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/price-optimization?page=${page}`
    ),

  generate: (payload: GeneratePriceOptimizationPayload = {}) =>
    api.post<{ data: PriceOptimizationInsight }>('/price-optimization/generate', payload),

  show: (id: number) => api.get<{ data: PriceOptimizationInsight }>(`/price-optimization/${id}`),

  destroy: (id: number) => api.delete(`/price-optimization/${id}`),
};
